import { render, staticRenderFns } from "./HuishouOrder.vue?vue&type=template&id=274f060a&scoped=true&"
import script from "./HuishouOrder.vue?vue&type=script&lang=js&"
export * from "./HuishouOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274f060a",
  null
  
)

export default component.exports